import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { Alert } from 'react-bootstrap-5';

import { connect } from 'react-redux';

import { scrollToRef } from 'helpers/scrolling';

export function DealFormErrors({ className, errors }) {
  const ref = useRef();

  useEffect(() => {
    if (errors) {
      scrollToRef(ref);
    }
  }, [errors]);

  if (!errors) {
    return null;
  }

  return (
    <Alert className={classNames(className)} variant="warning">
      <div className="fs-large mb-1" ref={ref}>
        <strong>Whoops -</strong> There were errors in the form that prevented saving.
      </div>
      <ul className="mb-0">
        {errors.map((error, i) => <li key={i}>{error}</li>)}
      </ul>
    </Alert>
  );
}

DealFormErrors.propTypes = {
  className: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = state => ({
  errors: state.deal.errors,
});

export default connect(mapStateToProps)(DealFormErrors);
